import { Dropdown } from 'react-bootstrap'
import { type TableColumn } from 'react-data-table-component'
import { ActionButton } from '../../components/DataTable/ActionButton'
import { CustomDropdownItem } from '../../components/Dropdown/CustomDropdownItem'
import { type InviteResponse } from '../../store/auth/auth'
import { type TeamRow } from './teamRows'

export interface RequestedRowActionHandlers {
  canAssign: boolean
  canBuy: boolean
  onAssignSeat: (invite: InviteResponse) => void
  onBuySeat: (invite: InviteResponse) => void
  onRevokeRequest: (invite: InviteResponse) => void
}

export const buildRequestedActionsColumn = ({
  canAssign,
  canBuy,
  onAssignSeat,
  onBuySeat,
  onRevokeRequest,
}: RequestedRowActionHandlers): TableColumn<TeamRow> => ({
  ignoreRowClick: true,
  right: true,
  button: true,
  allowOverflow: true,
  width: '3rem',
  cell: (row) =>
    row.kind === 'invite' ? (
      <ActionButton>
        {canAssign ? (
          <Dropdown.Item as={CustomDropdownItem} onClick={() => onAssignSeat(row.invite)}>
            Assign a seat
          </Dropdown.Item>
        ) : null}
        {!canAssign && canBuy ? (
          <Dropdown.Item as={CustomDropdownItem} onClick={() => onBuySeat(row.invite)}>
            Buy a seat
          </Dropdown.Item>
        ) : null}
        <Dropdown.Item as={CustomDropdownItem} onClick={() => onRevokeRequest(row.invite)}>
          <span className='zocks-text-danger'>Revoke</span>
        </Dropdown.Item>
      </ActionButton>
    ) : null,
})
